export default __webpack_public_path__ + "static/media/DCP_0003.8a25b67b.JPG";